import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';

export const getCouponExpiryDate = (coupon?: Coupon | null) => {
  if (!coupon?.type) {
    return undefined;
  }

  switch (coupon.type.$case) {
    case 'simpleCoupon':
      return coupon.type.simpleCoupon.expiryDate;
    case 'hotDealCoupon':
      return coupon.type.hotDealCoupon.expiryDate;
    case 'minimumOrderValueCoupon':
      return coupon.type.minimumOrderValueCoupon.expiryDate;
    case 'highTierCoupon':
      return coupon.type.highTierCoupon.expiryDate;
    default:
      return undefined;
  }
};
